import React from "react";

import Section from "../shared/section";
import BlogCard from "./blog-card";
import Blog1 from "../../images/blogs/blog-thumb-1.png";
import Blog2 from "../../images/blogs/blog-thumb-2.jpg";
import Blog3 from "../../images/blogs/blog-thumb-3.png";

import "./style.scss";

const Blogs = () => {
    return (
        <Section
            id="blogs"
            // title="Blogs & Articles"
            title="BLOGS & ARTICLES"
            background="dark"
        >
            <div className="blogs-content-wrapper">
                <BlogCard
                    user="Sandesh Bhujbal"
                    date="Aug 8 2023"
                    image={Blog1}
                    title="JWT Authentication"
                    description="JWT authentication streamlines user authentication by securely transmitting data between client and server using digitally signed tokens."
                    link="https://medium.com/@sandesh__30_/jwt-authentication-a47cb5389bd6"
                />
                <BlogCard
                    user="Sandesh Bhujbal"
                    date="Aug 8 2023"
                    image={Blog2}
                    title="Git Terminology"
                    description="Git, a distributed version control system, comes with a unique set of terminologies that are fundamental to understanding its workflow."
                    link="https://medium.com/@sandesh__30_/git-terminology-5e095ea7332d"
                />
                <BlogCard
                    user="Sandesh Bhujbal"
                    date="Aug 17 2023"
                    image={Blog3}
                    title="MVC Design Pattern"
                    description="The Model-View-Controller (MVC) design pattern is a structured approach to software architecture."
                    link="https://medium.com/@sandesh__30_/mvc-design-pattern-ff40d66990e3"

                />
            </div>
        </Section>
    );
};

export default Blogs;
